module.exports = __webpack_public_path__ + "img/caas4-m@1.f347015c.webp";